'use client';

import Link from 'next/link';
import ScrollToFormLink from './ScrollToFormLink';

export default function StickyCTA() {
  return (
    <div  className="fixed inset-x-0 bottom-0 z-50 lg:hidden bg-white/95 border-t border-slate-200 shadow-[0_-8px_24px_rgba(15,23,42,0.08)] backdrop-blur-sm">
      <div id='enroll-now-referral-cta' className="container  mx-auto px-4 py-3 flex items-center gap-3">
        <ScrollToFormLink
          className="flex-1 rounded-full bg-[#FFC907] px-4 py-3 text-center text-sm font-semibold text-[#1A325D]"
        >
          Start Referring
        </ScrollToFormLink>
        <Link
          href="/referral/check-status"
          className="flex-1 rounded-full border border-[#1A325D] bg-white px-4 py-3 text-center sm:text-xs text-sm font-semibold text-[#1A325D]"
        >
          View Referral Status
        </Link>
      </div>
    </div>
  );
}
